// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Popconfirm, Radio } from "antd";
import { NewsAddBlockButtonProps } from "../../../types/NewsTypes";
import { InfoCircleOutlined, PlusCircleOutlined } from "@ant-design/icons/lib";
import { useStore } from "effector-react";
import { TemplateStore } from "../../../../state/template/TemplateStore";
import { TemplateDTO } from "../../../../utils/htmlTemplate/dto/template.dto";

export const NewsAddBlocButton: React.FunctionComponent<NewsAddBlockButtonProps> = (
  props: NewsAddBlockButtonProps
) => {
  const { t } = useTranslation();

  const templatesStore: TemplateDTO[] | null = useStore(TemplateStore);

  const { handleAddBlock, index, buttonLabel } = props;

  const radioStyle = {
    display: "block",
    height: "40px",
    lineHeight: "40px"
  };

  const [template, setTemplate] = useState<TemplateDTO>();

  const popconfirmTitle = (
    <>
      <div>
        <strong>{t("news.global_buttons.block.pop_confirm.title")}</strong>
      </div>
      <div className="my-2">
        <Radio.Group
          buttonStyle="outline"
          onChange={e =>
            setTemplate(
              templatesStore.filter(temp => temp.name === e.target.value)[0]
            )
          }
        >
          {templatesStore.map((temp: TemplateDTO) => (
            <Radio style={radioStyle} key={temp.name} value={temp.name}>
              {temp.name}
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </>
  );

  return (
    <Popconfirm
      title={popconfirmTitle}
      okText={t("global.confirm")}
      cancelText={t("global.cancel")}
      placement="top"
      icon={<InfoCircleOutlined />}
      onConfirm={() => {
        if (template) {
          // Deep copy
          const inputs = JSON.parse(JSON.stringify(template.format.inputs));
          inputs.forEach((input: any) => delete input.properties);
          handleAddBlock(
            {
              idTempLocal: require("shortid").generate(),
              templateId: template.id,
              inputs
            },
            index
          );
        }
      }}
    >
      <Button className="btn-secondary m-2">
        <PlusCircleOutlined /> {buttonLabel}
      </Button>
    </Popconfirm>
  );
};
